import React from 'react'
import Breadcrumbs from '../components/Breadcrumbs/Breadcrumbs'
import SitemapLayout from '../components/SitemapLayout/SitemapLayout'
import useFetch from '../hooks/useFetch'
import { Spinner } from 'react-bootstrap'
import ErrorComponent from '../components/ErrorComponent/ErrorComponent'

function Sitemap() {
  const transferData = (resp) => resp.data
  const { data, loading, error } = useFetch('sitemap', transferData)
  const {
    breadcrumbs = [],
    pagetitle: pageTitle,
    sectiondata = [],
  } = data || {}

  if (loading) {
    return (
      <div className="flex justify-center mt-8">
        <Spinner />
      </div>
    )
  }

  return (
    <>
      {error?.hasError ? (
        <div className="flex justify-center">
          <ErrorComponent errorMessage={error.errorMessage} />
        </div>
      ) : (
        <>
          <div className="page-container">
            <div className="page-header text-center mt-2 mb-10 md:mt-2 md:mb-20">
              {pageTitle}
            </div>
            <SitemapLayout sitemapData={sectiondata || []} />
          </div>
          <Breadcrumbs breadcrumbs={breadcrumbs} />
        </>
      )}
    </>
  )
}

export default Sitemap
